export const descConfig = [
    __(
        'ACATS (Automated Customer Account Transfer Service) is a system that automates and standardizes the transfer of assets in a customer account from one brokerage firm and/bank to another.'
    ),
    __(
        'Before you start to transfer your external account to TradeUP, please make sure you have the necessary information ready.'
    )
];

export const tipsConfig: string[] = [
    __('Confirm that the external account type matches your TradeUP account. '),
    __('The name on your external account should be identical to your TradeUP account.'),
    __('Have your external account open so you can retrieve your account number and brokerage statement. ')
];
